import script from "./MenuSelectedApi.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuSelectedApi.vue?vue&type=script&setup=true&lang=js"

import "./MenuSelectedApi.vue?vue&type=style&index=0&id=741a3d79&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741a3d79"]])

export default __exports__